// @core/api/endpoints/notifications/set_contact_verified.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetContactVerifiedRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Verify contact with code
 * Completes the contact verification process using a code sent to the contact. Verified contacts can receive notifications.
 * @public This endpoint does not require authentication
 */
export async function SetContactVerified(
  contact_id: string,
  data: SetContactVerifiedRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id/verify`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
